import { TaskStatus, WorkflowCode, WorkflowStepCode } from '@exam-management/graphql';

import type { QuestionCreationTask } from '../../types';

export const DEFAULT_QUESTION_CREATION_TASK_DETAILS: QuestionCreationTask = {
  assignee: {
    id: '',
    firstname: '',
    lastname: '',
  },
  assignerId: '',
  code: '',
  createdAt: new Date(),
  dueDate: new Date(),
  id: '',
  metadata: {
    requirement: {
      details: null,
      qBankStructure: null,
      requiredQuestionCount: null,
      questionCreationCount: 0,
      itemSetCreation: null,
      itemSetCondition: null,
    },
  },
  name: '',
  currentWorkflowStep: {
    code: WorkflowStepCode.QuestionCreationTodo,
    name: '',
    workflowCode: WorkflowCode.QuestionCreation,
  },
  ownerId: '',
  owner: {
    id: '',
    firstname: '',
    lastname: '',
  },
  status: TaskStatus.Todo,
  updatedAt: new Date(),
  taskEntities: [],
};
